export default __webpack_public_path__ + "static/SRF Carabrew 6GF6911 - Product Specifications & Technical Data-ad6cfefd3883e3b9c95bf976990f2553.pdf";